var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.45801H17.9C17.6679 3.32942 17.0538 2.31535 16.1613 1.58673C15.2687 0.858098 14.1522 0.459462 13 0.458008L11 0.458008C9.8478 0.459462 8.73132 0.858098 7.83875 1.58673C6.94618 2.31535 6.3321 3.32942 6.1 4.45801H5C3.67441 4.4596 2.40356 4.98689 1.46622 5.92423C0.528882 6.86157 0.00158786 8.13241 0 9.45801L0 19.458C0.00158786 20.7836 0.528882 22.0545 1.46622 22.9918C2.40356 23.9291 3.67441 24.4564 5 24.458H19C20.3256 24.4564 21.5964 23.9291 22.5338 22.9918C23.4711 22.0545 23.9984 20.7836 24 19.458V9.45801C23.9984 8.13241 23.4711 6.86157 22.5338 5.92423C21.5964 4.98689 20.3256 4.4596 19 4.45801ZM11 2.45801H13C13.6183 2.46057 14.2206 2.65409 14.7247 3.0121C15.2288 3.3701 15.6099 3.8751 15.816 4.45801H8.184C8.39008 3.8751 8.77123 3.3701 9.2753 3.0121C9.77937 2.65409 10.3817 2.46057 11 2.45801ZM5 6.45801H19C19.7956 6.45801 20.5587 6.77408 21.1213 7.33669C21.6839 7.8993 22 8.66236 22 9.45801V12.458H2V9.45801C2 8.66236 2.31607 7.8993 2.87868 7.33669C3.44129 6.77408 4.20435 6.45801 5 6.45801ZM19 22.458H5C4.20435 22.458 3.44129 22.1419 2.87868 21.5793C2.31607 21.0167 2 20.2537 2 19.458V14.458H11V15.458C11 15.7232 11.1054 15.9776 11.2929 16.1651C11.4804 16.3527 11.7348 16.458 12 16.458C12.2652 16.458 12.5196 16.3527 12.7071 16.1651C12.8946 15.9776 13 15.7232 13 15.458V14.458H22V19.458C22 20.2537 21.6839 21.0167 21.1213 21.5793C20.5587 22.1419 19.7956 22.458 19 22.458Z",
    fill: "#02BC49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.458008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroD);
export default __webpack_public_path__ + "static/media/astroD.49d96fcfeb6a2baf995869f71b221d29.svg";
export { ForwardRef as ReactComponent };